// extracted by mini-css-extract-plugin
module.exports = {"mediaOrderInfo":"styles_mediaOrderInfo__2tNFI","customerOrderId":"styles_customerOrderId__1vrrr"};